import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import styles from "./calenderController.module.css";

interface CalendarControllerProps {
  currentDate: Date;
  week: Date[];
  weekOffset: number;
  onCurrentWeek: () => void;
  onPreviousWeek: () => void;
  onNextWeek: () => void;
  showPrevious?: boolean;
  isDailyView?: boolean; 
  selectedDate?: Date | null; 
  dayOffset?: number; 
}

export default function CalendarControler({
  currentDate,
  week,
  weekOffset,
  onCurrentWeek,
  onPreviousWeek,
  onNextWeek,
  showPrevious = true,
  isDailyView = false,
  selectedDate = null,
  dayOffset = 0,
}: CalendarControllerProps) {
  return (
    <>
      <div className={styles.CalendarControllerCurrent}>
        <span onClick={onCurrentWeek}>
          {currentDate.toLocaleString("default", { month: "long" })} - {currentDate.getFullYear()}
        </span>
      </div>
      <div className={styles.CalendarControllerNavigation}>
        <span
          onClick={ onPreviousWeek}
        >
          <IoIosArrowBack className={styles.icon} />
        </span>
        <span>
          {isDailyView && selectedDate ? (
            `${selectedDate.getDate().toString().padStart(2, "0")} ${selectedDate.toLocaleString("default", { month: "long" })} ${selectedDate.getFullYear()}`
          ) : (
            week[0]?.getMonth() === week[week.length - 1]?.getMonth() ? (
              `${week[0]?.getDate().toString().padStart(2, "0")} - ${week[week.length - 1]?.getDate().toString().padStart(2, "0")} ${week[0]?.toLocaleString("default", { month: "long" })} ${week[0]?.getFullYear()}`
            ) : (
              `${week[0]?.getDate().toString().padStart(2, "0")} ${week[0]?.toLocaleString("default", { month: "long" })} - ${week[week.length - 1]?.getDate().toString().padStart(2, "0")} ${week[week.length - 1]?.toLocaleString("default", { month: "long" })} ${week[0]?.getFullYear()}`
            )
          )}
        </span>
        <span onClick={onNextWeek}>
          <IoIosArrowForward className={styles.icon} />
        </span>
      </div>
    </>
  );
}
